import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "../../contexts/auth/Context";
import { useToast } from "../../contexts/toast/Context";
import {
  getOperatingHoursRequest,
  updateOperatingHoursRequest,
  type DayOperatingHours,
} from "../requests/gym";
import { CACHE_TIMES } from "../../query/options";

const OPERATING_HOURS_QUERY_KEY = ["gym", "operatingHours"] as const;

export const useOperatingHours = () => {
  const { token } = useAuth();
  const { showToast } = useToast();
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: OPERATING_HOURS_QUERY_KEY,
    queryFn: () => getOperatingHoursRequest(token!),
    enabled: !!token,
    ...CACHE_TIMES.MASTER_DATA,
  });

  const mutation = useMutation({
    mutationFn: (operatingHours: DayOperatingHours[]) =>
      updateOperatingHoursRequest({ operatingHours }, token!),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: OPERATING_HOURS_QUERY_KEY });
      showToast("Horarios de operación actualizados", "success");
    },
    onError: (err: Error) => {
      showToast(err.message ?? "Error al actualizar horarios", "error");
    },
  });

  return {
    operatingHours: query.data?.operatingHours ?? null,
    isLoading: query.isLoading,
    update: mutation.mutate,
    isUpdating: mutation.isPending,
  };
};
